export { default } from './AislesMenuMobile';
